import React from 'react';
import cn from 'classnames';
import Subtitle from 'components/UI/Subtitle';
import * as styles from './Steps.module.scss';

export default function Steps({ title, steps, className }) {
  return (
    <section className={cn(styles.wrapper, className)}>
      {title && (
        <Subtitle size="lg" className={styles.title}>
          {title}
        </Subtitle>
      )}
      {steps.map(step => (
        <div key={step} className={styles.step}>
          <p className={styles.stepTitle}>{step}</p>
        </div>
      ))}
    </section>
  );
}
